import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Button,
  CircularProgress,
} from "@mui/material";
import axios from "../../../config/axiosConfig";
import Alert from "@mui/material/Alert";

// Estado 5 (Entregado) de la OT Prueba: espejo simplificado de concluyendo.php. Sin
// precio (el formulario de precio de ese archivo es código muerto — variables PHP que
// nunca se asignan, ver otPruebaModel.js) y sin bifurcación por tipo de servicio: la
// OT siempre salta a Finalizado (7) al concluir.
const headCellSx = {
  fontWeight: 800,
  bgcolor: (t) => (t.palette.mode === "dark" ? t.palette.background.paper : t.palette.grey[100]),
};
const tableSx = { "& .MuiTableCell-root": { py: 0.1, px: 0.6, fontSize: 10.5, lineHeight: 1.3 } };

const ConcluirPruebaOT = ({ cod_ot, onConcluido }) => {
  const [items, setItems] = useState([]);
  const [observacion, setObservacion] = useState("");
  const [loading, setLoading] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    axios.get(`/api/ot-prueba/asignados/${cod_ot}`)
      .then((res) => setItems(res.data || []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, [cod_ot]);

  const concluir = async () => {
    if (!window.confirm("¿Concluir esta OT de Prueba? Los equipos quedarán Activos y la OT Finalizada.")) return;
    setGuardando(true);
    setError("");
    try {
      const res = await axios.patch(`/api/ot-prueba/finalizar/${cod_ot}`, { observacion });
      if (onConcluido) onConcluido(res.data);
    } catch (err) {
      setError(err?.response?.data?.error || "No se pudo concluir la OT.");
    } finally {
      setGuardando(false);
    }
  };

  if (loading) {
    return <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}><CircularProgress size={20} /></Box>;
  }

  return (
    <Box sx={{ mt: 1 }}>
      {error && <Alert severity="error" sx={{ mb: 1.5 }}>{error}</Alert>}

      <Typography variant="subtitle2" sx={{ fontWeight: 800, mb: 0.5 }}>
        Equipos asignados a prueba
      </Typography>
      <TableContainer component={Paper} variant="outlined" sx={{ mb: 2, maxHeight: 320, borderRadius: 0.5 }}>
        <Table size="small" stickyHeader sx={tableSx}>
          <TableHead>
            <TableRow>
              <TableCell sx={headCellSx}>Identificador</TableCell>
              <TableCell sx={headCellSx}>Modelo</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!items.length ? (
              <TableRow>
                <TableCell colSpan={2}>
                  <Typography variant="body2" color="text.secondary" sx={{ fontStyle: "italic" }}>
                    No hay equipos asignados en esta OT.
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              items.map((r) => {
                const key = `${r.familia}-${r.identificador}`;
                return (
                  <TableRow key={key} hover>
                    <TableCell>{r.identificador}</TableCell>
                    <TableCell>{r.modelo}</TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <TextField
        label="Observación de Conclusión"
        fullWidth
        multiline
        rows={3}
        value={observacion}
        onChange={(e) => setObservacion(e.target.value)}
        sx={{ mb: 2 }}
      />

      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button variant="contained" color="success" onClick={concluir} disabled={guardando}>
          {guardando ? <CircularProgress size={20} color="inherit" /> : "Concluir"}
        </Button>
      </Box>
    </Box>
  );
};

export default ConcluirPruebaOT;
